import { fetchAmount, fetchGrossAmount, fetchNetSalary } from "../features/salarycalculator/salary.slice";

export function handleToggle(setToggleState: React.Dispatch<React.SetStateAction<string | null>>, id: string) {
  setToggleState(prevId => (prevId === id ? null : id));
}

export const getSocialFeeByAge = (ageRange: string): number => {
  const ageFeeMap: Record<string, number> = {
    '0-66 years': 23.91,
    '67-89 years': 9.26,
    '> 90 years': 0,
  };
  return ageFeeMap[ageRange] ?? 0;
};

export const defaultWorkingHour = () => ({
  id: 0,
  number: '',
  unit: '',
  amountPerUnitSek: 0,
  amountPerUnit: 0,
  articleNumber: '88',
  workingDescription: 'Mileage Report',
  houseworkType: '',
  workingHour: 0,
  isTaxFreeArticle: false,
  isArticleShownInInvoice: true,
  isPdfAttachedToInvoice: true,
  tripStartedPlace: '',
  tripEndedPlace: '',
  distance: '',
  country: '',
  allowancePerDay: 0,
  reasonForTrip: '',
  carRegistrationNo: '',
  vat: 25,
  amount: 0,
  totalDayOfTravels: 0,
  allowanceDestination: '',
  expenseCategory: '',
  fileName: '',
  fileContent: '',
  amountInSek: 2.5,
  isHalfDay: '1',
  articleId: 0,

});


export const defaultForm = (workingHours: any[] = []) => ({
  vat: 25,
  travel: 0,
  allowance: 0,
  pension: false,
  amount: 0,
  rutDeduction: false,
  rootDeduction: false,
  expressPayout: false,
  holidaySavings: false,
  pensionFee: 0,
  pensionAmount: 0,
  tax: 30,
  fee: 1.4,
  expenditureForMaterialsAndToolsTaxFreeAmount: 0,
  HourlyWagesAmount: 0,
  rutTaxValue: 0,
  socialFee: getSocialFeeByAge('0-66 years'),
  rootTaxValue: 0,
  expressFee: 0,
  holidaySavingsFee: 0,
  currencyRate: '1',
  currencyName: 'SEK',
  userId: 0,
  invoiceType: 1,
  numberOfFreelancers: 1,
  workingHours,
});

export const netorGrossDefaultForm = (workingHours: any[] = []) => ({
  NetAmount: 0,
  salaryAfterTax: 0,
  GrossAmount: 0,
  Vat: 25,
  Tax: 30,
  CurrencyRate: 1,
  CurrencyName: '',
  Fee: 0.0,
  Allowance: 0.00,
  Travel: 0.0,
  SocialFee: 23.91,
  RootDeduction: false,
  RutDeduction: false,
  RootTaxValue: 0,
  RutTaxValue: 0,
  ExpressPayout: false,
  ExpressFee: 0,
  HolidaySavings: false,
  Pension: false,
  HolidaySavingsFee: 0,
  UserId: 0,
  CustomerId: 0,
  PensionFee: 0,
  PensionAmount: 0,
  HolidayDeduction: 0,
  ExpenditureForMaterialsAndToolsTaxFreeAmount: 0,
  HourlyWagesAmount: 0,
  OtherCostAmount: 0,
  InvoiceType: 1,
  NumberOfFreelancers: 1,
  year: 1960,
  workingHours,
});

// Constants
export const CURRENCIES = ['SEK', 'USD', 'EUR', 'GBP'];
export const VAT_OPTIONS = ['0', '6', '12', '25'];
export const AGE_RANGES = [
  { label: '0-66 years', value: '0-66 years' },
  { label: '67-89 years', value: '67-89 years' },
  { label: '> 90 years', value: '> 90 years' },
];

export const TAB_CONFIG = {
  invoice: {
    amountField: 'amount',
    label: 'INVOICE_AMOUNT',
    placeholder: 'ENTER_YOUR_INVOICE_AMOUNT',
    action: fetchAmount
  },
  gross: {
    amountField: 'GrossAmount',
    label: 'GROSS_SALARY',
    placeholder: 'ENTER_PRE_TAX_SALARY',
    action: fetchGrossAmount
  },
  net: {
    amountField: 'NetAmount',
    label: 'NET_SALARY',
    placeholder: 'ENTER_NET_SALARY',
    action: fetchNetSalary
  },
};
export const formatNumberWithCommas = (value: string | number): string => {
  if (!value || value === "00") return "00";
  const cleanValue = value.toString().replace(/,/g, '');
  return isNaN(Number(cleanValue)) ? value.toString() : Number(cleanValue).toLocaleString();
};
export const formatNumberSwedish = (value: string | number): string => {
  if (!value || value === "00") return "00";
  const cleanValue = value.toString().replace(/ /g, '').replace(/,/g, '.');
  return isNaN(Number(cleanValue))
    ? value.toString()
    : new Intl.NumberFormat('sv-SE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(Number(cleanValue));
};


export const tabs = [
  { key: 'invoice', label: 'INVOICE_AMOUNT' },
  { key: 'gross', label: 'GROSS_SALARY' },
  { key: 'net', label: 'NET_SALARY' },
];
export const PENSION_OPTIONS = ['1000', '1500', '2000', '2500', '3000'];
export const HOLIDAY_PAY = ['12', '20', '30', '40', '50']

export const articleNumbers = [
  { articleNumber: "97", description: "agreed" },
  { articleNumber: "92", description: "hour" },
  { articleNumber: "87", description: "Mileage Report" },
  { articleNumber: "85", description: "Allowance outside Sweden" },
  { articleNumber: "91", description: "Travel Expenses as per attached PDF" },
  { articleNumber: "83", description: "Allowance in Sweden" },
  { articleNumber: "2",  description: "Expenses for material and tools as per attached pdf" }
];

export const ALLEXPENSESDATA = [
  { type: 'mileage', label: 'MILEAGE_REIMBURSEMENT' },
  { type: 'travel', label: 'TRAVEL_EXPENSES' },
  { type: 'materials', label: 'EXPENSES_FOR_MATERIALS_AND_TOOLS' },
  { type: 'allowance_sweden', label: 'ALLOWANCE_IN_SWEDEN' },
  { type: 'allowance_outside_sweden', label: 'ALLOWANCE_OUTSIDE_SWEDEN' },
]